import { render } from "./TablaFamilias.vue?vue&type=template&id=d2292928&ts=true"
import script from "./TablaFamilias.vue?vue&type=script&lang=ts"
export * from "./TablaFamilias.vue?vue&type=script&lang=ts"

import "./TablaFamilias.vue?vue&type=style&index=0&id=d2292928&lang=scss"

import exportComponent from "/opt/build/repo/front-panel/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__